import {
  RowsDescriptor,
  SelectAllState,
  UpdateRowsDescriptor,
} from '@tmx/operandi';

export const EMPTY_ROWS_DESCRIPTOR: RowsDescriptor = new UpdateRowsDescriptor(
  [],
  0,
  0,
  0,
  SelectAllState.Deselected
);
